<template>
  <!-- The app's v-calendar picker, as DateRange uses it: clicking the box opens the calendar. -->
  <DatePicker
    :value="value"
    mode="date"
    :masks="{ input: ['MM/DD/YYYY'], data: ['YYYY-MM-DD'] }"
    :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
    :popover="{ visibility: disabled ? 'hidden' : 'focus' }"
    @input="$emit('input', $event || null)"
  >
    <template #default="{ inputValue, inputEvents }">
      <input
        class="form-control group-date-input"
        :value="inputValue"
        :disabled="disabled"
        :aria-label="ariaLabel"
        :data-cy="dataCy"
        placeholder="MM/DD/YYYY"
        v-on="inputEvents"
      />
    </template>
  </DatePicker>
</template>

<script lang="ts">
import { DatePicker } from 'v-calendar'
import { Component, Prop, Vue } from 'vue-property-decorator'

/** A single date for the group editor, as `YYYY-MM-DD`; v-model emits null when cleared. */
@Component({ components: { DatePicker } })
export default class GroupDateInput extends Vue {
  @Prop({ type: String, default: null }) value!: string | null
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  @Prop({ type: String, required: true }) ariaLabel!: string
  @Prop({ type: String, default: null }) dataCy!: string | null
}
</script>

<style lang="scss" scoped>
.group-date-input {
  width: 140px;

  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
}
</style>
